import React from "react";
import { Switch, Route } from "react-router-dom";
import checkPermissions from "./checkPermissions";

/*
 * options: 
     watchQuery: 查询参数变化时是否刷新页面，默认false
 */
const AclRoutes = ({
  routes,
  authorities,
  watchQuery = false,
  extraProps = {},
  switchProps = {},
}) => {
  const { location } = window;

  function renderComponent(hasPermissions, props, route) {
    const component = hasPermissions
      ? <route.component {...props} {...extraProps} route={route} />
      : <route.unauthorized {...props} />;

    return component;
  }

  return routes ? (
    <Switch {...switchProps}>
      {routes.map((route, i) => {
        const hasPermissions = checkPermissions(authorities, route.permissions);

        return (
          <Route
            key={
              watchQuery ? location.pathname + location.search : route.key || i
            }
            path={route.path}
            exact={route.exact}
            strict={route.strict}
            render={(props) => renderComponent(hasPermissions, props, route)}
          />
        );
      })}
    </Switch>
  ) : null;
};

export default AclRoutes;
